import React from "react"


class Roles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <section>

            </section>
        )
    }

}

export default Roles


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/Roles.js